import React from 'react';
import { Paper, Typography } from '@mui/material';
import { formatCurrency } from '../../../utils/dashboard';

interface SummaryCardProps {
  title: string;
  value: number;
  color: string;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  value,
  color
}) => {
  return (
    <Paper elevation={1} sx={{ 
      px: 1.2,
      py: 1,
      borderRadius: 0.5,
      bgcolor: '#2a2a2a',
      border: `2px solid ${color}`,
      minWidth: 120,
      boxShadow: `0 0 2px 0 ${color}22`
    }}>
      <Typography variant="body2" sx={{ color: '#888', mb: 0.5, fontSize: 11 }}>
        {title}
      </Typography>
      <Typography variant="h5" sx={{ 
        color,
        fontWeight: 600,
        fontSize: 15
      }}>
        {formatCurrency(value)}
      </Typography>
    </Paper>
  );
};

export default SummaryCard; 